import React, { useState } from 'react'
import { FaStripe } from "react-icons/fa";
import { TbBrandPaypalFilled } from "react-icons/tb";
import { GiDigitalTrace } from "react-icons/gi";
import PaymentDetails from './PaymentDetails';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { getTransactionDetails } from '../../redux/Slices/datasetSlice';
import { useSelector } from 'react-redux';

const publisable_key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
const stripePromise = loadStripe(publisable_key);

function PaymentType({feedBack}) {

const data = useSelector(getTransactionDetails)
const [paymentToShow, setPaymentToShow] = useState(null)


function togglePayment(category){
    setPaymentToShow(category)
}

  return (
    <div className='bg-[#F3EDED] text-black  h-[90vh] w-full
    overflow-y-scroll md:h-[80%] rounded-lg py-7 md:px-12'>

    <div className='my-5 space-y-1'>
      <h3 className='font-semibold text-2xl text-center'>Payment Method</h3>
      <p className='font-light text-md text-center'>All transactions are secure and encrypted</p>
    </div>

    <div className='flex flex-col justify-center bg-[#FFFFFF] rounded-lg border-black mx-4'>
    

    <button 
    onClick={() => {
        if(paymentToShow === "stripe"){
            togglePayment(null)
        }else{
            togglePayment("stripe")
        }
    }}
    className='flex items-center px-2.5 py-1 border-black border-[0.4px] rounded-t-lg '>
    <div className='border-[1px] border-black rounded-full h-5 w-5 mr-6 ml-4' />
    <FaStripe className='text-[#6a59c4] text-6xl' />
    </button>

    <div className={` ${paymentToShow === "stripe" ? "py-6 h-auto opacity-100" : "h-0 opacity-0"}`}>
    {data?.price &&
    <Elements stripe={stripePromise}>
    <PaymentDetails sendResponse={feedBack} />
    </Elements>
     }
    </div>

    <button 
    onClick={() => {
        if(paymentToShow === "paypal"){
            togglePayment(null)
        }else{
            togglePayment("paypal")
        }
    }}
    className='flex items-center py-2.5 px-2.5 border-black border-[0.4px] '>
    <div className='border-[1px] border-black rounded-full h-5 w-5 mr-5 ml-4' />
     <p className='text-[#0079C1] text-xl font-extrabold'>
     <TbBrandPaypalFilled className='text-[#00457C] text-4xl md:text-5xl inline' />
     <span className='text-[#00457C] ml-2'>Pay</span>Pal
     </p>
    </button>

    <button 
    onClick={() => {
        if(paymentToShow === "crypto"){
            togglePayment(null)
        }else{
            togglePayment("crypto")
        }
    }}
    className='flex items-center py-2.5 px-2.5 border-black border-[0.4px] rounded-b-lg'>
    <div className='border-[1px] border-black rounded-full h-5 w-5 mr-5 ml-4' />
     <p className='text-[#00457C] text-xl font-extrabold'>
     <GiDigitalTrace className='text-[#00457C] text-4xl md:text-5xl inline mr-3' />
     crypto.com
     </p>
    </button>

    </div>

    </div>
  )
}

export default PaymentType
